export default [
    {
        path: "/admin/canteen/setting/group",
        component: () => import("../Components/List.vue"),
        name: "canteen.setting.group",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/canteen/setting/migration",
        component: () => import("../Components/BranchMigration.vue"),
        name: "canteen.setting.migrate",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/canteen/setting/year-migration",
        component: () => import("../Components/YearMigration.vue"),
        name: "canteen-setting-year-migrate",
        meta: {
            requiresAuth: true,
        },
    },
];
